import { render, staticRenderFns } from "./ModalCPESunat.vue?vue&type=template&id=1028d680&"
import script from "./ModalCPESunat.vue?vue&type=script&lang=js&"
export * from "./ModalCPESunat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports